export const USER_LOADING = "src/User/USER_LOADING";
export const USER_ERROR = "src/User/USER_ERROR";
export const SET_USERS = "src/User/SET_USERS";
